module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--2--redeem-93454be2.png";